export default "__VITE_ASSET__e8391348__"